import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { InsightsService } from './insights.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ChartConfiguration, ChartEvent, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import * as dayjs from 'dayjs';
import { DateTransformPipe } from '../pipes/date-transform.pipe';
import { CommonServiceService } from '../services/common-service.service';
import { AlertService } from '../alert/alert.service';
import * as $ from 'jquery';
import moment from 'moment';
import 'daterangepicker';
import {mock} from './mock';
import { NgOtpInputComponent, NgOtpInputConfig } from 'ng-otp-input';

export interface DialogData {
  data: any;
}
@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss'],
  providers: [mock, DateTransformPipe]
})
export class InsightsComponent implements OnInit {
  botListArray: any = [];
  mapArray: any = [];
  dropdown_icon:boolean=false;
  dropdown_botname='';
  dropdown_filter =''
  showKycStatusBar=false
  kycDocumentsUploaded=false;
  options = {
    autoClose: false,
    keepAfterRouteChange: false
  };
  userIC = 0;
  userICpercentage = "0%";
  businessIC = 0;
  businessICpercentage = "0%";
  B_IC = true;
  U_IC = true;
  rangePicker:any;
  custom_from_date:any;
  custom_to_date:any;
  shortYear = new Date().toLocaleString('default', { year: '2-digit' });
  min:number =  0;
  max:number =  100;
  slideIndex = 1;

  @ViewChild('StartDate') matStartDate;
  @ViewChild('EndDate') matEndDate;
  botSelected;

  selected: {startDate: dayjs.Dayjs, endDate: dayjs.Dayjs};
  merchantID: string;
  loginUserDetails: any
  apiKeyIsGenerated: boolean = false;
  kycDocuments:any=[];
  filterdt = 'month';

  constructor(private insightsService: InsightsService, private _matDialog: MatDialog, private _snackBar: MatSnackBar,
    private pipe: DateTransformPipe,private commonService:CommonServiceService, private mock: mock,
    public alertService: AlertService) { 
      this.chartReset();
     }

  ngOnInit(): void {
    this.getMerchantDetails()
    if (localStorage.getItem('merchantDetails')) {
      this.loginUserDetails = JSON.parse(localStorage.getItem('merchantDetails'))
      this.merchantID = this.loginUserDetails.merchant_id;
      this.getKYCDocuments()
    } else {
      this._snackBar.open("Please login first", 'close', {
        duration: 3000,
        horizontalPosition: 'end',
        verticalPosition: 'top',
      });
    }
   
   if(localStorage.getItem('apiKey')) {
    this.apiKeyIsGenerated = true;
    this.getBotDetails();
  }else{
    this.getApiKey()
  }
    // setTimeout(() => {
    //   $(function() {
    //     var start = moment().subtract(29, 'days');
    //     var end = moment();
    //     function cb(start, end) {
    //         $('#reportrange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
    //     }
    //     $('#reportrange').daterangepicker({
    //         startDate: start,
    //         endDate: end,
    //         ranges: {
    //           'Today': [moment(), moment()],
    //           'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    //           'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    //           'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    //           'This Month': [moment().startOf('month'), moment().endOf('month')],
    //           'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    //         }
    //     }, cb);
    //   });
    //   const ref = this;
    //   $('#reportrange').on('apply.daterangepicker', function(ev, picker) {
    //     ref.filterdt = 'custom'
    //     ref.custom_from_date = picker.startDate._d,
    //     ref.custom_to_date= picker.endDate._d
    //     ref.getConversations(ref.botSelected, 'custom');
    //   });
    // }, 3000);

  }

  iconChange(){
    this.dropdown_icon = !this.dropdown_icon
  }
  updateCustomDate(){
    
    this.filterdt = 'custom'
    this.getConversations(this.botSelected, 'custom');
  }
  
  getApiKey() {
    this.insightsService.getApiKey(this.loginUserDetails.merchant_id).subscribe(
      (res) => {
        localStorage.setItem('apiKey', res.body.api_key);
        this.apiKeyIsGenerated = true;
        this.getBotDetails();
      },
      (error) => {
        // this._snackBar.open(error.error.message, 'close', {
        //   duration: 3000,
        //   horizontalPosition: 'end',
        //   verticalPosition: 'top',
        // });
      }
    );
  }
  chartReset() {
    this.mapArray = [];
    this.userIC = 0;
    this.businessIC = 0;
    this.chart?.update();
    
  }
  getKYCDocuments(){
    this.commonService.getUploadedDocuments(this.merchantID).subscribe(response => {
     this.kycDocuments =response.data
     if( this.kycDocuments.length !== 0){
      let verificationDocTypes = []
      this.kycDocuments.forEach(element => {
       verificationDocTypes.push(element.verification_type)
      });
      if(verificationDocTypes.includes('NAME')&&verificationDocTypes.includes('ADDRESS')){
        this.kycDocumentsUploaded =true
      }
     }
    
    });
  }

getMerchantDetails(){
  this.commonService.getMerchantDetail().subscribe(
    data =>{
      if(data.status !== "ACTIVE" && data.status !== "REJECTED"){
        this.showKycStatusBar =true
      }
     
    }
  )
}
  public lineChartType: ChartType = 'line';

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
  public chartClicked({ event, active }: { event?: ChartEvent, active?: {}[] }): void { }

  public chartHovered({ event, active }: { event?: ChartEvent, active?: {}[] }): void { }

  getBotDetails() {
    this.insightsService.getBotlist(this.merchantID).subscribe(res => {
      this.botListArray = res.body.data;
      setTimeout(() => {
        if(res.body.data[0]?.bot_id){
          this.botSelected = res.body.data[0]?.bot_id;
          this.dropdown_botname= res.body.data[0]?.name;
          this.dropdown_filter = "This month";
          this.getConversations(this.botSelected, 'month');
          this.showSlides(this.slideIndex);
        }
        
      }, 300)
    },
      error => {
        this.alertService.error(error.error.message, this.options);
      }
    );
  }

  public hideOne(event, val): void {
    const isHidden = this.chart?.isDatasetHidden(val);
    this.chart?.hideDataset(val, !isHidden);
    if(val === 0) this.U_IC = !this.U_IC;
    else if(val === 1) this.B_IC = !this.B_IC;
  }

  calculateMinMax(data) {
    data.sort((a, b) => new Date(a.conversation_start_date).getTime() - new Date(b.conversation_start_date).getTime());
    const userMax = Math.max.apply(Math, data.map(function(o) { return o.user_initiated_conversations; }));
    const userMin = Math.min.apply(Math, data.map(function(o) { return o.user_initiated_conversations; }));
    const businessMax = Math.max.apply(Math, data.map(function(o) { return o.business_initiated_conversations; }));
    const businessMin = Math.min.apply(Math, data.map(function(o) { return o.business_initiated_conversations; }));
    if(userMin<businessMin) this.min = userMin;
    else this.min = businessMin;
    if(userMax>businessMax) this.max = userMax;
    else this.max = businessMax;
    if(this.max < 10) this.max = 10;
    this.mapArray = data.map(x => {
      x.conversation_start_date = moment(x.conversation_start_date).valueOf();
      return x;
    });
  }

  getConversations(e, data) {
    let botId = (typeof e === 'string') ? e : e.target.value;
    if(botId && data) {
      let date = {from : null, to: null};
      if(data === 'yesterday') {
        date.from = this.pipe.transform(new Date(new Date().setDate(new Date().getDate() - 1)), 'dateWithHyphen');
        date.to = this.pipe.transform(new Date(new Date().setDate(new Date().getDate() - 1)), 'dateWithHyphen');
      } else if(data === 'week') {
        date.from = this.pipe.transform(new Date(new Date().setDate(new Date().getDate() - 7)), 'dateWithHyphen');
        date.to = this.pipe.transform(new Date(new Date().setDate(new Date().getDate() - 1)), 'dateWithHyphen');
      } else if(data === 'month') {
        date.from = this.pipe.transform(new Date(new Date().setDate(1)), 'dateWithHyphen');
        date.to = this.pipe.transform(new Date(new Date()), 'dateWithHyphen');
      } else if(data === 'custom') {
        date.from = this.pipe.transform(this.custom_from_date, 'dateWithHyphen');
        date.to = this.pipe.transform(this.custom_to_date, 'dateWithHyphen');
      }
      this.insightsService.getConversations(botId, date).subscribe(res => {
        // this.mapArray = this.mock.zoom;
        this.calculateMinMax(res.data);
        this.userIC = this.mapArray.reduce((a, b) => a + (b['user_initiated_conversations'] || 0), 0);
        this.businessIC = this.mapArray.reduce((a, b) => a + (b['business_initiated_conversations'] || 0), 0);
        let AllIC = this.userIC+this.businessIC;
        this.userICpercentage = (this.userIC *100)/AllIC+"%";
        this.businessICpercentage = (this.businessIC * 100)/AllIC+"%";
      },
        error => {
          this.userICpercentage = "0%";
          this.businessICpercentage = "0%";
          this.chartReset();
        }
      );
    }
  }

  openApiGenerateKeyPopup() {
    const otpDialog=this._matDialog.open(ApiKeyDialog, {
      data: ''
    });
    otpDialog.afterClosed().subscribe((result) => {
      this.getApiKey()
      if(result?.data?.api_key){
        this.apiKeyIsGenerated = true;
       
      }
      
    })
    
  }

  goToLink(url: string){
    window.open(url, "_blank");
  }
  
  currentSlide(n) {
    this.showSlides(this.slideIndex = n);
  }
  showSlides(n) {
    let i;
    let slides = Array.from(document.getElementsByClassName('custom-card') as HTMLCollectionOf<HTMLElement>);
    console.log(slides)
    let dots = Array.from(document.getElementsByClassName('w3-badge') as HTMLCollectionOf<HTMLElement>);
    if (n > slides.length) {this.slideIndex = 1}    
    if (n < 1) {this.slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";  
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[this.slideIndex-1].style.display = "block";  
    dots[this.slideIndex-1].className += " active";
  }
  
}


@Component({
  selector: 'api-key-dialog',
  templateUrl: './api-key.html',
  styleUrls: ['./insights.component.scss']
})
export class ApiKeyDialog {
  apiKey: string
  merchantID: string;
  loginUserDetails: any;
  showError: boolean = false;
  openGenerateAPi: boolean = true
  constructor(public dialogRef: MatDialogRef<ApiKeyDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private _snackBar: MatSnackBar, private _matDialog: MatDialog,
    private insightsService: InsightsService, private route: Router,private service: CommonServiceService) {
    this.loginUserDetails = JSON.parse(localStorage.getItem('loginUserDetails'))
    this.merchantID = this.loginUserDetails.merchant_id;
  }

  getApiKeyOTP() {
    this.service
      .getApiKeyOTP(this.merchantID)
      .subscribe((res) => {
      });
  }

  GenerateOtpPopup() {
    this.dialogRef.close();
    const otpDialog=this._matDialog.open(OtpGenerateDialog, {
    });
  
  } 

  goToCreateBot() {
    this.dialogRef.close({event: 'close',data:{"api_key":this.apiKey}})
    this.route.navigate(['/bots/create-bot'])
  }

  closePopup() {
    this.dialogRef.close();
  }
}


@Component({
  selector: 'generate-otp-dialog',
  templateUrl: 'generate-otp-dialog.html',
  styleUrls: ['./insights.component.scss'],
})
export class OtpGenerateDialog {
  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;
  apiKeyRegenereted: boolean = false;
  
  otp: number;
  timeLeft: number = 40;
  interval: any;
  otpNumber;
  merchantDetails: any;
  newAPIKey: string;
  showNotification: boolean = false;
  notificationMessage: string;
  invalidOtpNotification:boolean = false;
  InvalidMessage: string;
  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    inputStyles:{'border': '1px solid #C3D2FC'},
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
  };
  apiKey: any;
  constructor(public dialogRef: MatDialogRef<OtpGenerateDialog>,private service: CommonServiceService,
    private insigntsService: InsightsService,) {
  this.merchantDetails = JSON.parse(localStorage.getItem('merchantDetails'));
    this.startTimer();
  }

  onOtpChange(otp) {
    this.otp = otp;
  }
  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft != 0) {
        if (this.timeLeft > 0) {
          this.timeLeft--;
        } else {
          this.timeLeft = 40;
        }
      } else {
        this.timeLeft = 0;
      }
    }, 1000);
  }

  confirmOTP(){
    this.config.inputStyles ={'border': '1px solid #C3D2FC'}
    let request = {
      otp: this.otp,
    };
    this.service
    .verifyApiKeyOTP(this.merchantDetails.merchant_id, request)
    .subscribe((res) => {
      let response = JSON.parse(res);
      let token = response.token;
     
      let request ={
        "token":token
      }
      this.insigntsService.generateApiKey(this.merchantDetails.merchant_id,request).subscribe(res => {
        this.apiKeyRegenereted = true;
        this.apiKey = res.body.api_key
        localStorage.setItem('apiKey',res.body.api_key)
      }, error => {
        this.apiKeyRegenereted = false;
      })
      
    },(error)=>{
        let wrongOtp = JSON.parse(error.error)
        if(wrongOtp.message){
          this.invalidOtpNotification=true;
          this.config.inputStyles ={'border': '1px solid #EB5757'}
          this.InvalidMessage = wrongOtp.message
        }
        setTimeout(()=>{                         
          this.invalidOtpNotification = false;
          
      }, 4000);
    });
  }
  

  resendOTP() {
    this.service.getApiKeyOTP(this.merchantDetails.merchant_id).subscribe(
      (res) => {},
      (error) => {
        let errorMessage= JSON.parse(error.error)
        if (errorMessage.message) {
          this.showNotification = true;
          this.notificationMessage = errorMessage.message;
        }
        setTimeout(()=>{                         
          this.showNotification = false;
      }, 4000);
      }
    );
  }


  closePopup() {
    this.dialogRef.close();
    if(this.apiKeyRegenereted){
      window.location.reload()
    }
  }
}

